import styled from "styled-components";

export const AreaButtonFilters = styled.div`
	display: flex;
	justify-content: flex-end;
	gap: 1rem;

	> button {
		max-width: fit-content !important;
	}

	@media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
		flex-direction: column;

		> button {
			width: 100%;
			max-width: unset !important;
			margin: 0;
		}
	}
`;

export const RowInputs = styled.div`
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 16px;
	margin-bottom: 16px;

	@media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
		grid-template-columns: repeat(2, 1fr);
	}

	@media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
		grid-template-columns: 1fr;
	}
`;
